import * as React from 'react';
import { CartService } from '../../Cart/types';
import { ServiceSummary } from '../../features/service-summary';
const InsuranceSummary = props => {
    return (React.createElement(ServiceSummary, { serviceType: "Insurance", renderSummary: groups => {
            const items = groups.reduce((items, group) => [
                ...items,
                ...group.items.map(item => (Object.assign(Object.assign({}, item), { included: !props.onServiceDelete || item.included, downloadUrl: props.isDownload ? item.downloadUrl : null, onDelete: props.onServiceDelete && item.deleteMeta
                        ? () => props.onServiceDelete(CartService.Insurances, item.deleteMeta)
                        : null })))
            ], []);
            return props.children(items);
        } }));
};
export default InsuranceSummary;
